import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import formatDatalayerEcommerce from "../../helpers/formatDatalayerEcommerce";

export default function ProductSetAdd({
  items,
  itemsHash,
  itemStockStatuses,
  setProduct,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const totalQuantity = items.reduce((total, item) => total + item.quantity, 0);

  const disabled = loading || totalQuantity === 0;
  const text = loading
    ? window.localeStrings.product.adding_to_cart
    : window.localeStrings.product.set_add_all;

  useEffect(() => {
    document.querySelectorAll("[data-set-add-all]").forEach((el) => {
      el.disabled = disabled;
      el.innerHTML = text;
    });
  }, [disabled, text]);

  const addAll = () => {
    const itemsToAdd = items
      .map(({ variant, quantity }) => ({
        id: variant.id.replace("gid://shopify/ProductVariant/", ""),
        variant,
        quantity,
      }))
      .filter((item, i) => {
        const { status } = itemStockStatuses[i];
        return status.orderable;
      })
      .filter((item) => item.quantity > 0);

    setLoading(true);

    [{ variant: setProduct.variants[0], quantity: 1 }, ...itemsToAdd].forEach(
      ({ variant, quantity }) => {
        const customProperties = {
          is_quick_view: false,
          is_product_set: true,
          is_buy_now_button: false,
          quantity: `${quantity}`,
        };

        const ecommerce = formatDatalayerEcommerce({
          product: variant.product,
          variant,
          key: "add",
          customProperties,
        });

        window.ElevarDataLayer?.push({
          event: "dl_add_to_cart",
          ...ecommerce,
        });
      },
    );

    window.addToCart(
      itemsToAdd.map(({ id, quantity }) => ({
        id,
        quantity,
        properties: { _is_product_set: "true" },
      })),
      {
        onError: (response) => {
          setLoading(false);
          setError(
            response?.message || window.localeStrings.product.add_to_cart_error,
          );
          window.setTimeout(() => setError(null));
        },
        onAfterAdd: () => {
          setLoading(false);
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
      },
    );
  };

  useEffect(() => {
    const handleOtherAtcClick = (e) => {
      if (!e.target.closest("[data-set-add-all]")) return;

      addAll();
    };
    document.addEventListener("click", handleOtherAtcClick);
    return () => document.removeEventListener("click", handleOtherAtcClick);
  }, [itemsHash]);

  return (
    <>
      <button
        type="button"
        className="button button--black button--full product-form-set__submit"
        onClick={addAll}
        disabled={disabled}
      >
        {text}
      </button>
      {error !== null && (
        <div className="product-form-set__submit-error">{error}</div>
      )}
    </>
  );
}
